module.exports = __webpack_public_path__ + "static/img/SMT-DcgK3LLR.14b45ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/SMT-DcgK3LLR.png
// module id = RDdU
// module chunks = 16